<div class="dashboard-container">
    <header class="dashboard-header">
        <app-header class="header-full-width" title="ComplyTRI Administration"></app-header>
    </header>
    <div class="dashboard-main">
        <mat-sidenav-container class="dashboard-sidenav-container">
            <mat-sidenav mode="side" opened class="dashboard-sidenav">
                <mat-nav-list>
                    @for (item of navItems; track $index) {
                    <a mat-list-item class="nav-link" [routerLink]="item.path" #link="routerLinkActive" routerLinkActive
                        [activated]="link.isActive">
                        {{ item.title }}
                    </a>
                    @if (item.children) {
                    <mat-nav-list>
                        @for (child of item.children; track $index) {
                        <a mat-list-item class="child-link" [routerLink]="child.path" #childLink="routerLinkActive"
                            routerLinkActive [activated]="childLink.isActive">
                            {{ child.title }}
                        </a>
                        }
                    </mat-nav-list>
                    }
                    }
                </mat-nav-list>
            </mat-sidenav>
            <mat-sidenav-content class="dashboard-content">
                <!-- Main content here -->
                <div class="dashboard-scrollable-content">
                    <router-outlet></router-outlet>
                </div>
            </mat-sidenav-content>
        </mat-sidenav-container>
    </div>
</div>